export enum ThirdPartyReportShowCategoryEnum {
    Speed,
    OperationalReport,
    UkReport,
    Main
}
